import React, { useState, useEffect } from "react";
import EmailIcon from "../assets/images/login-flow/mail.svg";
import backArrow from "../assets/images/login-flow/back-arrow.svg";
import { Link } from "react-router-dom";
import { Form, Button, Col, Row } from "react-bootstrap";
import "../scss/login.scss";

import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, clearMessages } from "../features/auth/authActions";
import { getPageContent } from "../features/visitor/visitorActions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify"; // Import toast
import { Helmet } from "react-helmet-async";

function ForgotPassword() {

  
  const [headerData, setHeaderData] = useState(null);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();

  const { loading, successMessage, errorMessage } = useSelector(
    (state) => state.auth
  );
  const { pageResponse } = useSelector((state) => state.visitor);

  const validate = () => {
    const errors = {};

    // Check for empty fields
    if (!email) errors.email = "Email is required.";
    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email))
      errors.email = "Invalid email format.";
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Initial blank errors
    setErrors({});

    // Validate form inputs
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Dismiss any currently visible toasts
    toast.dismiss();

    // Dispatch Forgot password action
    let data = {
      email_or_mobile: email,
    };
    dispatch(forgotPassword(data));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, { autoClose: 3000, hideProgressBar: true });
      setEmail("");
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
    }
    dispatch(clearMessages());
  }, [successMessage, errorMessage, dispatch]);

  
  useEffect(() => {
    dispatch(getPageContent());
  }, [dispatch]);
  
  useEffect(() => {
    if(pageResponse){
      let footer = pageResponse.find(r => r.code === 'footer');
      setHeaderData(footer.footer_section);
    }
  }, [pageResponse]);


  return (
    <>
      <Helmet>
        <title>Forgot Password | Helpotani</title>
        <meta
          name="description"
          content="Reset your password to regain access to your Helpotani account. Enter your email to receive password reset instructions."
        />
        <meta
          name="keywords"
          content="Forgot Password, Reset Password, Account Recovery, Helpotani, Password Assistance"
        />
      </Helmet>

      <section className="login">
        <div className="login-box">
          <Link to="/" className="logo-img">
          <img src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${headerData?.main_logo}`} alt="" />
          </Link>
          <h1>Forgot Password?</h1>
          <p>No Worries, We’ll send you reset instructions.</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmailname" className="form-group mb-50">
              <Form.Label>Email Address</Form.Label>
              <div className="input-group">
                <Form.Control
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  isInvalid={!!errors.email}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>

                <img src={EmailIcon} alt="Enter your email" />
              </div>
            </Form.Group>

            <Button disabled={loading} className="custom-bttn" type="submit">
              {loading ? (
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                  size="lg"
                  className="spinner-icon"
                />
              ) : (
                "Reset Password"
              )}
            </Button>

            <Row>
              <Col className="text-center">
                <p className="login-footer-text">
                  <Link to="/login">
                    <img src={backArrow} alt="Back to Log In" /> Back to Log In
                  </Link>{" "}
                </p>
              </Col>
            </Row>
          </Form>
        </div>
      </section>
    </>
  );
}
export default ForgotPassword;
